import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { useSeo } from "@/lib/seo";
import ArticleCard from "@/components/public/ArticleCard";
import { Reveal } from "@/components/public/Reveal";
import { BrushUnderline } from "@/components/public/Brush";

export default function Category() {
  const { slug } = useParams();
  const { categories } = useSettings();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const cat = categories.find((c) => c.slug === slug);
  const name = cat?.name || slug.replace(/-/g, " ");

  useSeo({ title: `${name} | Lucrative Laptop`, description: cat?.description || `${name} stories from Lucrative Laptop.` });

  useEffect(() => {
    setLoading(true);
    api.get("/public/posts", { params: { category: slug, limit: 30 } }).then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, [slug]);

  const feature = posts[0];
  const rest = posts.slice(1);

  return (
    <div className="max-w-[1600px] mx-auto px-5 lg:px-10 pt-10 pb-12">
      <div className="relative mb-14">
        <span aria-hidden="true" className="pointer-events-none select-none absolute -top-6 lg:-top-10 -left-2 font-poster text-stroke text-[7rem] lg:text-[13rem] leading-none opacity-40">/</span>
        <div className="relative">
          <div className="flex items-center gap-3 mb-3"><span className="w-6 h-0.5 bg-brand" /><span className="label-mono">Section</span></div>
          <h1 className="font-poster uppercase text-white leading-[0.88] text-6xl lg:text-8xl">
            <span className="relative inline-block">{name}<BrushUnderline className="absolute left-0 -bottom-3 w-full h-5 text-brand" /></span>
          </h1>
          {cat?.description && <p className="text-white/60 mt-6 text-lg max-w-2xl">{cat.description}</p>}
        </div>
      </div>

      {loading ? (
        <div className="text-brand font-mono-label" data-testid="category-loading">loading stories...</div>
      ) : posts.length === 0 ? (
        <div className="text-white/60 py-20 text-center font-hand text-3xl" data-testid="category-empty">No stories here yet. Check back soon.</div>
      ) : (
        <div data-testid="category-list">
          {feature && <div className="mb-8"><Reveal><ArticleCard post={feature} variant="hero" /></Reveal></div>}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((p, i) => <Reveal key={p.slug} delay={(i % 3) * 0.06}><ArticleCard post={p} variant="default" /></Reveal>)}
          </div>
        </div>
      )}
    </div>
  );
}
